export const userData = [
    {
      name: "Jan",
      "Active User": 4000,
    },
    {
      name: "Feb",
      "Active User": 3000,
    },
    {
      name: "Mar",
      "Active User": 5000,
    },
    {
      name: "Apr",
      "Active User": 4000,
    },
    {
      name: "May",
      "Active User": 3000,
    },
    {
      name: "Jun",
      "Active User": 2000,
    },
    {
      name: "Jul",
      "Active User": 4000,
    },
    {
      name: "Agu",
      "Active User": 3000,
    },
    {
      name: "Sep",
      "Active User": 4000,
    },
    {
      name: "Oct",
      "Active User": 1000,
    },
    {
      name: "Nov",
      "Active User": 4000,
    },
    {
      name: "Dec",
      "Active User": 3000,
    },
  ];

  export const productData = [
    {
      name: "Jan",
      "Sales": 4000,
    },
    {
      name: "Feb",
      "Sales": 3000,
    },
    {
      name: "Mar",
      "Sales": 5000,
    },
  ];

  export const userRows = [
    {
      id: 1,
      username: "A",
      avatar:
        "https://wallpaperaccess.com/full/1476273.jpg",
      email: "pingtouser@gmail.com",
      status: "active",
      transaction: "$120.00",
    },
    {
      id: 2,
      username: "B",
      avatar:
        "https://wallpaperaccess.com/full/1476290.jpg",
      email: "pingtouser@gmail.com",
      status: "active",
      transaction: "$120.00",
    },
    {
      id: 3,
      username: "M",
      avatar:
        "https://wallpaperaccess.com/full/1476358.jpg",
      email: "pingtouser@gmail.com",
      status: "active",
      transaction: "$120.00",
    },
    {
      id: 4,
      username: "N",
      avatar:
        "https://wallpaperaccess.com/full/1476324.jpg",
      email: "pingtouser@gmail.com",
      status: "active",
      transaction: "$120.00",
    },
    {
      id: 5,
      username: "R",
      avatar:
        "https://wallpaperaccess.com/full/1476289.jpg",
      email: "pingtouser@gmail.com",
      status: "active",
      transaction: "$120.00",
    },
    {
      id: 6,
      username: "S",
      avatar:
        "https://wallpaperaccess.com/full/1315536.jpg",
      email: "pingtouser@gmail.com",
      status: "active",
      transaction: "$120.00",
    },
    {
      id: 7,
      username: "X",
      avatar:
        "https://i.ibb.co/DQ7VWfj/X-Name-Red-Fire-DP-Image-Download-1.jpg",
      email: "pingtouser@gmail.com",
      status: "active",
      transaction: "$120.00",
    },
    {
      id: 8,
      username: "Y",
      avatar:
        "https://wallpaperaccess.com/full/1476380.jpg",
      email: "pingtouser@gmail.com",
      status: "active",
      transaction: "$120.00",
    },
    {
      id: 9,
      username: "Jon Snow",
      avatar:
        "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      email: "pingtouser@gmail.com",
      status: "active",
      transaction: "$120.00",
    },
    {
      id: 10,
      username: "Jon Snow",
      avatar:
        "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      email: "pingtouser@gmail.com",
      status: "active",
      transaction: "$120.00",
    },
  ];

  export const productRows = [
    {
      id: 1,
      name: "thyronorm-75mcg",
      img:
        "https://www.practostatic.com/practopedia-images/v3/res-750/thyronorm-75mcg-tablet-120s_ac41f26e-04bf-41c4-be11-5c75dffe3e2f.JPG",
      stock: 13,
      status: "available",
      price: "142.93",
    },
    {
      id: 2,
      name: "Lipitor (Atorvastatin Calcium)",
      img:
        "https://cdn.shopify.com/s/files/1/0562/3853/8907/products/lipitor-_atorvastatin-calcium_-20mg-x30-tabs-1_kjvg2h_800x.jpg",
      stock: 8,
      status: "available",
      price: "2300",
    },
    {
      id: 3,
      name: "Calcimax Forte",
      img:
        "https://5.imimg.com/data5/ED/GY/IH/GLADMIN-3061/calcimax-forte-nutritional-supplement-tablet-30-tab-bottle-500x500.jpg",
      stock: 12,
      status: "available",
      price: "143.50",
    },
    {
      id: 4,
      name: "Liveasy Wellness Calcium",
      img:
        "https://cdn01.pharmeasy.in/dam/products_otc/T22634/liveasy-wellness-calcium-magnesium-vitamin-d3-zinc-bones-dental-health-bottle-60-tabs-2-1643876895.jpg",
      stock: 7,
      status: "available",
      price: "299.5",
    },
    {
      id: 5,
      name: "Everherb Jointcare",
      img:
        "https://cdn01.pharmeasy.in/dam/products_otc/Y79593/everherb-jointcare-blend-of-9-powerful-herbs-joint-bone-health-bottle-of-60-tablets-2-1643876387.jpg",
      stock: 10,
      status: "available",
      price: "499.5",
    },
    {
      id: 6,
      name: "Electric Heating Wrap Black",
      img:
        "https://cdn01.pharmeasy.in/dam/products_otc/R05584/jus-amazin-crunchy-organic-peanut-butter-unsweetened-1kg-clean-nutrition-2-1642006742.jpg",
      stock: 15,
      status: "available",
      price: "1119",
    },
    {
      id: 7,
      name: "Nepro Hp Vanilla Nutrition",
      img:
        "https://cdn01.pharmeasy.in/dam/products_otc/I13844/nepro-hp-vanilla-toffee-flav-pow-400gm-2-1641787950.jpg",
      stock: 18,
      status: "available",
      price: "722.5",
    },
    {
      id: 8,
      name: "Relief Diphenhydramine HCl",
      img:
        "https://m.media-amazon.com/images/I/81ROkatqrLL._AC_SL1500_.jpg",
      stock: 5,
      status: "available",
      price: "819.44",
    },
    {
      id: 9,
      name: "Relief Diphenhydramine HCl",
      img:
        "https://m.media-amazon.com/images/I/81ROkatqrLL._AC_SL1500_.jpg",
      stock: 5,
      status: "available",
      price: "819.44",
    },
    {
      id: 10,
      name: "Electric Heating Wrap Black",
      img:
        "https://cdn01.pharmeasy.in/dam/products_otc/R05584/jus-amazin-crunchy-organic-peanut-butter-unsweetened-1kg-clean-nutrition-2-1642006742.jpg",
      stock: 15,
      status: "available",
      price: "1119",
    },
  ];
  export const homeAbout = [
    {
      id: 1,
      cover: "https://www.uberlikeapp.com/images/products/pharmacy-delivery-app/icons/search.svg",
      title: "Find Medicine",
      desc: "With the help of the search box provided, users can search for medicines online available in their nearby location. It will start giving suggestions as soon as you type the name of a medicine. If the suggestion doesn’t come up, you can still search for medicine by entering a proper name.",
    },
    {
      id: 2,
      cover: "https://i.ibb.co/BV6RPwj/drs-pharma-order-medicine-home-delivery.png",
      title: "Order Medicine",
      desc: "Users can order some standard medicine from our web application. Users can order items by clicking add to cart after going to cart, users order it to their address.",
    },
    {
      id: 3,
      cover: "https://i.ibb.co/YfqnyDs/online-medicine-concept-digital-online-medical-care-online-doctor-pharmacist-medical-consultation-do.png",
      title: "Doctor consultancy",
      desc: "User can consult doctor where they can detail of the doctor and user get the contact details, his /her expertise.",
    },
  ];
  export const awrapper = [
    {
      cover: "https://img.icons8.com/external-yogi-aprelliyanto-basic-outline-yogi-aprelliyanto/80/ffffff/external-graduation-education-yogi-aprelliyanto-basic-outline-yogi-aprelliyanto.png",
      data: "3,000",
      title: "SUCCESS STORIES",
    },
  
    {
      cover: "https://img.icons8.com/ios/80/ffffff/athlete.png",
      data: "320",
      title: "TRUSTED TUTORS",
    },
    {
      cover: "https://img.icons8.com/external-outline-icons-maxicons/80/ffffff/external-calender-insurance-outline-outline-icons-maxicons.png",
      data: "1,000",
      title: "SCHEDULES",
    },
    {
      cover: "https://img.icons8.com/ios/80/ffffff/macbook-idea--v3.png",
      data: "587",
      title: "COURSES",
    },
  ];